import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { sessionOnInit } from '../session/store/session.selectors';

@Component({
	selector: 'main-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

	public isOnInit$: Observable<boolean>;

	constructor( private store: Store<AppState> ) {
		this.isOnInit$ = this.store.select( sessionOnInit );
	}

	ngOnInit() {
	}

}
